import {FieldPolicy} from '@apollo/client';

import {hasMoreMessages as hasMoreMessagesVar} from '../../query/Chat.gql';

/**
 * Implementation of local field that indicates whether chat has more history.
 */
export const hasMoreMessages: FieldPolicy = {
  read(_, opts) {
    return hasMoreMessagesVar().get(opts.args?.id) || true;
  },
};
